
export enum PlaybackMode
{
    DoNotRepeat = "DoNotRepeat",
    RepeatAll = "RepeatAll",
    RepeatOne = "RepeatOne",
    Shuffle = "Shuffle"
}
